import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import { Web3Provider } from './providers/Web3Provider';
import './index.css';

// Override fetch to prepend API_BASE for /api routes in production
const API_BASE = import.meta.env.VITE_API_URL || '';
if (API_BASE) {
  const originalFetch = window.fetch;
  window.fetch = function (input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
    if (typeof input === 'string' && input.startsWith('/api')) {
      input = `${API_BASE}${input}`;
    }
    return originalFetch(input, init);
  };
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <Web3Provider>
    <App />
  </Web3Provider>
);
